import ResourceService from "./resource.service";

class POSDeviceService extends ResourceService {
  static get resource() {
    return "pos-device";
  }
}

export default POSDeviceService;
